module.exports = __webpack_public_path__ + "img/ic_information.e5b230c7.svg";